import { CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined, EyeOutlined, MoreOutlined } from "@ant-design/icons";
import { Button, Checkbox, ConfigProvider, Dropdown, Flex, Row, Space, Table, Tag } from "antd";
import TableAntd from "components/elements/Table/Table";
import StatusTag from "components/elements/TagCustom/StatusTag";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatDate } from "utils/formatter";
import dayjs from "dayjs";

const PendingApprovalEndorseTimeTable = ({
  modalFlag = true,
  isLoading = false,
  pagination = {},
  dataSource = [],
  onEdit = () => { },
  onReturn = () => { },
  onApprove = () => { },
  onApproveAll = () => { },
  onRejectAll = () => { },
  onReject = () => { },
  onCancel = () => { },
  onStatus = () => { },
  onChange = () => { },
  onOpenModal = () => { },
  pageType = ""
}) => {
  const { t, i18n } = useTranslation();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const hasSelected = selectedRowKeys.length > 0;

  const columns = [
    {
      title: <div className="text-table">{t('workin_location.label.reqid')}</div>,
      dataIndex: "sequence",
      key: "sequence",
      visible: true,
      align: "center",
    },
    {
      title: <div className="text-table">{t('name-surname')}</div>,
      dataIndex: "employee",
      key: "employee",
      visible: true,
      align: "center",
      render: (text, record) => {

        return i18n.language === 'en' ? <span>{record?.employee?.nameAndSurnameEn}</span> : <span>{record?.employee?.nameAndSurname}</span>
      }
    },
    {
      title: <div className="text-table">{t('employee.label.create-date')}</div>,
      dataIndex: "createDate",
      key: "createDate",
      visible: true,
      align: "center",
      render: (_, record) => {
        return record?.createDate ? dayjs(record?.createDate).format(i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB") : "-"
      }
    },
    {
      title: <div className="text-table">{t('my_request.label.create-date')}</div>,
      dataIndex: "endorseDate",
      key: "endorseDate",
      visible: true,
      align: "center",
      render: (_, record) => {
        return record?.endorseDate ? dayjs(record?.endorseDate).format(i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB") : "-"
      }
    },
    {
      title: <div className="text-table">{t('endorsement.label.start_time')}</div>,
      dataIndex: "startTime",
      key: "startTime",
      visible: true,
      align: "center",
    },
    {
      title: <div className="text-table">{t('endorsement.label.end_time')}</div>,
      dataIndex: "endTime",
      key: "endTime",
      visible: true,
      align: "center",
    },
    {
      title: <div className="text-table">{t('endorsement.label.total_duration')}</div>,
      dataIndex: "totalDuration",
      key: "totalDuration",
      visible: true,
      align: "center",
      render: (_, record) => {
        if (record.totalDurationHour === 0) {
          return i18n.language === "en" ? record.totalDurationMinute + " minutes" : record.totalDurationMinute + " นาที"

        } else {
          return i18n.language === "en" ? record.totalDurationHour + " H " + record.totalDurationMinute + " M" : record.totalDurationHour + " ชม." + record.totalDurationMinute + " นาที"
        }
      },
    },
    // {
    //   title: <div className="text-table">{t('pending_approval_endorse_time.label.endorse_type')}</div>,
    //   dataIndex: "endorseType",
    //   key: "endorseType",
    //   render: (text, record) => { return "mock" }
    // },
    // {
    //   title: <div className="text-table">{t('description.description')}</div>,
    //   dataIndex: "description",
    //   key: "description",
    //   visible: true,
    // },
    {
      title: <div className="text-table">{t('status.status')}</div>,
      dataIndex: "status",
      key: "status",
      align: "center",
      visible: true,
      render: (text, record) => {
        let language = i18n.language == "en" ? "En" : ""
        return <StatusTag value={(record?.["approveStatus" + language])} />

        // let tagColor = "green";
        // if (record?.approveStatusEn === "Pending") {
        //   tagColor = "blue";
        // } else if (record?.approveStatusEn === "Rejected" || record?.approveStatusEn === "Cancelled") {
        //   tagColor = "red";
        // }
        // return i18n.language === 'en' ? <Tag color={tagColor}>{record?.approveStatusEn}</Tag> : <Tag color={tagColor}>{record?.approveStatus}</Tag>
      },
    },
    {
      title: "",
      key: "action",
      align: "center",
      visible: modalFlag,
      width: "50px",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: [
                {
                  key: "1",
                  onClick: () => { onOpenModal(record); },
                  label: `${t("action.view")}`,
                  icon: (
                    <EyeOutlined
                      style={{ fontSize: "18px", color: "gray" }}
                    />
                  ),
                },
                {
                  key: "2",
                  onClick: () => onApprove({
                    ...record,
                    table: "PendingApprovalEndorseTimeTable"
                  }),
                  label: `${t("action.approve")}`,
                  icon: (
                    <CheckOutlined
                      style={{ fontSize: "18px", color: "gray" }}
                    />
                  ),
                },
                {
                  key: "3",
                  onClick: () => onReject({
                    ...record,
                    table: "PendingApprovalEndorseTimeTable"
                  }),
                  label: `${t("action.reject")}`,
                  icon: (
                    <CloseOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
              ],
            }}
          >
            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
          </Dropdown>
        </Space>
      ),
    },


  ];

  const visibleColumns = columns.filter((col) => col.visible);

  const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <Flex vertical gap={16}>
      <ConfigProvider
        theme={{
          components: {
            Table: {
              selectionColumnWidth: "45px"
            },
          },
        }}
      >
        <TableAntd
          loading={isLoading}
          style={{ backgroundColor: "white", width: "100%" }}
          pagination={{
            ...pagination,
            showTotal: (total, range) =>
              t("paginate.description")
                .replace("{min}", range[0])
                .replace("{max}", range[1])
                .replace("{total}", total),
          }}
          dataSource={dataSource}
          rowKey={(record) => record.id}
          columns={visibleColumns}
          onChange={onChange}
          scroll={{ x: true }}
          rowSelection={pageType === "view" ? rowSelection : undefined}
        />
      </ConfigProvider>

      {hasSelected && pageType === "view" &&
        (<Flex vertical gap={8} style={{ alignItems: "end" }}>
          <span>{`${t("common.selected")} ${selectedRowKeys.length} ${t("common.items")}`}</span>
          <Row style={{ gap: "8px" }}>
            <Button
              type="default"
              style={{ borderRadius: "8px", height: "40px" }}
              onClick={() => {
                const selectedRecords = dataSource.filter(item => selectedRowKeys.includes(item.id));
                onRejectAll(selectedRecords).then(() => {
                  setSelectedRowKeys([]);
                });
              }}
            >
              {t("request_approval.label.not_approved")}</Button>
            <Button
              type="primary"
              style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color" }}
              onClick={() => {
                const selectedRecords = dataSource.filter(item => selectedRowKeys.includes(item.id));
                onApproveAll(selectedRecords).then(() => {
                  setSelectedRowKeys([]);
                });
              }}
            >{t("request_approval.label.approve")}</Button>
          </Row>
        </Flex>)}
    </Flex>
  );
};

export default PendingApprovalEndorseTimeTable;
